import React, { useState, useEffect } from 'react';
import { Isotipo } from './Logo';

export default function InstallPrompt() {
  const [prompt, setPrompt]   = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      const dismissed = localStorage.getItem('pwa_install_dismissed');
      if (!dismissed) setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const instalar = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') setVisible(false);
  };

  const descartar = () => {
    localStorage.setItem('pwa_install_dismissed', '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-24 left-4 right-4 sm:left-auto sm:right-6 sm:w-80 z-[9990] bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-gray-100 dark:border-slate-700 p-4 flex items-start gap-3">
      <Isotipo className="h-10 w-10 shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-gray-900 dark:text-white text-sm">Instalar MONIMEX</p>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Agrega la app a tu pantalla de inicio para acceso rápido sin navegador.</p>
        <div className="flex gap-2 mt-3">
          <button onClick={instalar}
            className="flex-1 bg-blue-600 hover:bg-blue-700 text-white text-xs font-semibold py-1.5 rounded-lg transition">
            Instalar
          </button>
          <button onClick={descartar}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 text-xs px-2 transition">
            No, gracias
          </button>
        </div>
      </div>
      <button aria-label="Cerrar aviso de instalación" onClick={descartar} className="text-gray-300 hover:text-gray-500 shrink-0 text-lg leading-none">✕</button>
    </div>
  );
}
